module.exports = __webpack_public_path__ + "static/media/ER.7128b954.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ER.svg
// module id = 246
// module chunks = 0